import React from 'react';
import { paths } from 'client/shared/Paths';
import { useT } from 'client/i18n/hooks/useT';
import { useDateTimeFormatter } from 'client/i18n/hooks/useDateTimeFormatter';
import { useBrowserSize } from '../../contexts/BrowserSize';
import { BREAKPOINT_SMALL } from '../MarketingPagesShared/styles';
import { SocialLink } from './components/SocialLink';
import { clickedFooterLink } from './events';
import { MarketingAppButtons } from '../MarketingPagesShared/MarketingAppButtons';
import { TempMUMSSwitcher } from './TempMUMSSwitcher';
import {
  CompactCopyrightContainer,
  CopyrightContainer,
  FooterContainer,
  LinksContainer,
  SocialContainer,
  TextLink,
} from './styled';

function AppLinks() {
  return <MarketingAppButtons clickEventLocation="Footer" />;
}

function LegalLink() {
  const t = useT();

  return (
    <TextLink
      onClick={() => clickedFooterLink('Legal')}
      href={paths.legal.tos}
      target="_blank"
      rel="noopener noreferrer"
    >
      {t(
        'PublicWebsiteNavFooter.Legal',
        'Legal',
        'Link to terms of service legal web page'
      )}
    </TextLink>
  );
}

function Links() {
  const t = useT();

  return (
    <LinksContainer>
      <TextLink
        onClick={() => clickedFooterLink('Jobs')}
        href={paths.spotify.jobs.creationPlatform}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t(
          'PublicWebsiteNavFooter.Careers',
          'Careers',
          'Link to "Careers" web page'
        )}
      </TextLink>
      <LegalLink />
      <TextLink
        onClick={() => clickedFooterLink('Help')}
        href={paths.getHelpPage('home')}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('PublicWebsiteNavFooter.Help', 'Help', 'Link to "Help" web page')}
      </TextLink>
    </LinksContainer>
  );
}

function CompactCopyright() {
  return (
    <CompactCopyrightContainer>
      <LegalLink />
      <Copyright />
    </CompactCopyrightContainer>
  );
}

function SocialLinks() {
  return (
    <SocialContainer>
      <SocialLink platformName="facebook" />
      <SocialLink platformName="twitter" />
      <SocialLink platformName="instagram" />
    </SocialContainer>
  );
}
function Copyright() {
  const t = useT();
  const options = { year: 'numeric' } as Intl.DateTimeFormatOptions;
  const dateTimeFormatter = useDateTimeFormatter(options);

  return (
    <CopyrightContainer>
      {t(
        'PublicWebsiteNavFooter.SpotifyCopyright',
        '{CURRENT_DATE} © Spotify AB',
        'The spotify copyright at the current year',
        {
          CURRENT_DATE: dateTimeFormatter.format(new Date().getTime()),
        }
      )}
    </CopyrightContainer>
  );
}

function getFooterContentInOrder(width: number) {
  if (width <= BREAKPOINT_SMALL) {
    return (
      <>
        <AppLinks />
        <SocialLinks />
        <CompactCopyright />
      </>
    );
  }
  return (
    <>
      <Copyright />
      <Links />
      <SocialLinks />
      <AppLinks />
      <TempMUMSSwitcher />
    </>
  );
}

export const Footer = () => {
  const { width } = useBrowserSize();
  return <FooterContainer>{getFooterContentInOrder(width)}</FooterContainer>;
};
